import { NO_OP_MESSAGE__NATIVE } from '../../utils/constants';

export const useNotificationPermissionState = () => {
  throw Error(NO_OP_MESSAGE__NATIVE); // optional
};
